import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/contexts/AuthContext'
import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'
import { CookieBanner } from './components/CookieBanner.tsx'
import { installGlobalErrorHandlers } from '@/services/errorLogger'
import './styles/globals.css'

// Install global error handlers (window.onerror, unhandledrejection)
installGlobalErrorHandlers()

// Auto-reload when a lazy-loaded chunk is missing (typically after a deploy
// invalidates old asset hashes). Vite emits this event on import() failures.
// Anti-loop guard: do not reload more than once per 10s.
const RELOAD_KEY = 'vite-preload-error-reload-at'
window.addEventListener('vite:preloadError', (event) => {
  const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
  if (Date.now() - last < 10_000) {
    console.error('[Vite] Repeated preload error within 10s, aborting auto-reload', event)
    return
  }
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  event.preventDefault()
  window.location.reload()
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
            <App />
            <Toaster position="top-right" />
            <CookieBanner />
          </ErrorBoundary>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
